import PropTypes from 'prop-types'

import {Map} from 'immutable'

import guaranteedIcon from './guaranteed-icon.svg'

import './funeralPackageDetail.scss'

const MERCHANDISE_WITH_SUFFIX = ['Urn', 'Casket', 'OuterBurialContainer']

// Split a PascalCase subcategory ('OuterBurialContainer') into words ('Outer Burial Container').
const humanizedSubcategory = subcategory => subcategory.replace(/([a-z])([A-Z])/g, '$1 $2')

const FuneralPackageDetail = ({detail}) => {
  if (!detail) return null

  const isGuaranteed = detail.get('is-guaranteed') ||
    detail.get('guaranteed') ||
    false

  const name = detail.get('name') || detail.get('title') || null

  const formatName = ({data, subcategory}) => {
    if (!data)
      return data

    if (MERCHANDISE_WITH_SUFFIX.includes(subcategory))
      return `${data} ${humanizedSubcategory(subcategory)}`
    else
      return data
  }

  return (
    <div
      className='funeral-package-detail'
      data-testid='funeral-package-detail'>
      <div className='name'>{formatName({data: name, subcategory: detail.get('subcategory')})}</div>
      {
        isGuaranteed &&
        <img alt='guaranteed icon' className='guaranteed-icon' src={guaranteedIcon} />
      }
    </div>
  )
}

FuneralPackageDetail.propTypes = {detail: PropTypes.instanceOf(Map)}

export default FuneralPackageDetail

